var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hidden-sm-and-up bg"},[_c('div',{staticClass:"mobile_callme_wrap"},[_c('p',[_vm._v(" Copyright ©2024 弘绿元 . All Rights Reserved . 沪ICP备2025135305号 ")])])])
}]

export { render, staticRenderFns }